import { render } from "./profile-links.vue?vue&type=template&id=4e559a6e&scoped=true&lang=pug"
import script from "./profile-links.vue?vue&type=script&lang=js"
export * from "./profile-links.vue?vue&type=script&lang=js"

import "./profile-links.vue?vue&type=style&index=0&id=4e559a6e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e559a6e"]])

export default __exports__